import { render, staticRenderFns } from "./role-form.vue?vue&type=template&id=3323adb8&scoped=true"
import script from "./role-form.vue?vue&type=script&lang=js"
export * from "./role-form.vue?vue&type=script&lang=js"
import style0 from "./role-form.vue?vue&type=style&index=0&id=3323adb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323adb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3323adb8')) {
      api.createRecord('3323adb8', component.options)
    } else {
      api.reload('3323adb8', component.options)
    }
    module.hot.accept("./role-form.vue?vue&type=template&id=3323adb8&scoped=true", function () {
      api.rerender('3323adb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Roles/role-form.vue"
export default component.exports